import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

@Injectable()
export class DashboardService {

  path = '/dashboard';
  id: number;

  constructor(private baseService: BaseService) {}

  getPaginated(init: number, end: number, name: string) {
    return this.baseService.get(this.path, '', { init, end, name });
  }

  getActive() {
    return this.baseService.get(this.path, '', { init:0 })
  }

	getScheduleList(query?) {
		return this.baseService.get(this.path, '/schedule-list', query)
	}

	getActionPlanList(query?) {
		return this.baseService.get(this.path, '/action-plan-list', query)
	}

	getChecklistAnswers(query?) {
		return this.baseService.get(this.path, '/checklist-answers', query)
	}

	getUnconformitiesAnswers(query?) {
		return this.baseService.get(this.path, '/unconformities-answers', query)
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/dashboard.service.ts